import UpdateEmail from './UpdateEmail';

export default UpdateEmail;
